export enum UnityBridges {
  Main = 'Bridge',
  Lipsync = 'bridge_lipsync',
}
